import { atom, useSetRecoilState } from 'recoil';

type ReplyModalState = {
  open: boolean;
  collectionPath: string;
  threadId: string | null;
  prevData?: any;
  isReply?: boolean;
};

export const replyModalState = atom<ReplyModalState>({
  key: 'replyModalState',
  default: { open: false, collectionPath: '', threadId: null, prevData: undefined, isReply: false },
});

export function useReplyModal() {
  const set = useSetRecoilState(replyModalState);
  return {
    openReplyModal: ({ collectionPath, threadId, prevData, isReply }: { collectionPath: string; threadId: string; prevData?: any; isReply?: boolean }) =>
      set({ open: true, collectionPath, threadId, prevData, isReply }),
    closeReplyModal: () => set((prev) => ({ ...prev, open: false })),
  };
}


